const ReportBarChart = ({ title, value, max, displayValue }) => {
    const percentage = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;

    return (
        <article className="report-chart-card">
            <header>
                <h4>{title}</h4>
                <span>{displayValue}</span>
            </header>
            <div className="report-bar-track" role="img" aria-label={`${title}: ${displayValue}`}>
                <div className="report-bar-fill" style={{ width: `${percentage}%` }} />
            </div>
        </article>
    );
};

export default ReportBarChart;
